module.exports = __webpack_public_path__ + "static/favicon-44bf1862965a7f70d180fa8491d43185.ico";